[
  {
    "id": "MET-M7-L203-001",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Reken om: 3,2 km = ... m",
    "options": [
      "3.200 m",
      "320 m",
      "32 m",
      "32.000 m"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte_km_m",
    "familyId": "MET-KM-M-KOMMA",
    "explanation": "1 km = 1.000 m. 3 km = 3.000 m. 0,2 km = 200 m. Samen 3.200 m.",
    "distractorExplanations": {
      "1": "Je hebt met 100 vermenigvuldigd.",
      "2": "Je hebt met 10 vermenigvuldigd.",
      "3": "Je hebt met 10.000 vermenigvuldigd."
    }
  },
  {
    "id": "MET-M7-L203-002",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Wat is de oppervlakte van een driehoek met basis 6 cm en hoogte 4 cm?",
    "options": [
      "12 cm²",
      "24 cm²",
      "10 cm²",
      "6 cm²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_driehoek",
    "familyId": "MET-OPP-DRIEHOEK",
    "explanation": "Oppervlakte driehoek = (basis × hoogte) : 2. (6 × 4) : 2 = 24 : 2 = 12.",
    "distractorExplanations": {
      "1": "Je bent vergeten te delen door 2.",
      "2": "Je hebt opgeteld.",
      "3": "Je hebt alleen de basis genomen."
    }
  },
  {
    "id": "MET-M7-L203-003",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Reken om: 4.500 gram = ... kg",
    "options": [
      "4,5 kg",
      "45 kg",
      "0,45 kg",
      "450 kg"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_kg",
    "familyId": "MET-G-KG",
    "explanation": "1.000 gram = 1 kg. 4.500 : 1.000 = 4,5 kg.",
    "distractorExplanations": {
      "1": "Je hebt gedeeld door 100.",
      "2": "Je hebt gedeeld door 10.000.",
      "3": "Je hebt gedeeld door 10."
    }
  },
  {
    "id": "MET-M7-L203-004",
    "module": "Metriek",
    "difficulty": 203,
    "question": "De omtrek van een rechthoek is 30 cm. De lengte is 10 cm. Wat is de breedte?",
    "options": [
      "5 cm",
      "10 cm",
      "20 cm",
      "2,5 cm"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek_terug",
    "familyId": "MET-OMTREK-TERUG",
    "explanation": "Omtrek = 2 × lengte + 2 × breedte. 30 = 20 + 2 × breedte. 10 = 2 × breedte. Breedte = 5.",
    "distractorExplanations": {
      "1": "Dat zou een omtrek van 40 geven.",
      "2": "Dat is het restant van de omtrek zonder te delen door 2.",
      "3": "Rekenfout."
    }
  },
  {
    "id": "MET-M7-L203-005",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Hoeveel cm² is 1 dm²?",
    "options": [
      "100 cm²",
      "10 cm²",
      "1.000 cm²",
      "0,1 cm²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_omrekenen",
    "familyId": "MET-DM2-CM2",
    "explanation": "Bij oppervlakte gaat elke stap met ×100. 1 dm² = 100 cm².",
    "distractorExplanations": {
      "1": "Dat is bij lengte (dm naar cm = ×10).",
      "2": "Dat is bij inhoud (dm³ naar cm³ = ×1000).",
      "3": "Dat is de andere kant op."
    }
  },
  {
    "id": "MET-M7-L203-006",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Wat is de oppervlakte van een driehoek met basis 10 cm en hoogte 7 cm?",
    "options": [
      "35 cm²",
      "70 cm²",
      "17 cm²",
      "50 cm²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_driehoek",
    "familyId": "MET-OPP-DRIEHOEK-2",
    "explanation": "Oppervlakte driehoek = (basis × hoogte) : 2. (10 × 7) : 2 = 70 : 2 = 35 cm².",
    "distractorExplanations": {
      "1": "Je bent vergeten te delen door 2. Een driehoek is de helft van een rechthoek.",
      "2": "Je hebt 10 + 7 gedaan. Bij oppervlakte moet je vermenigvuldigen.",
      "3": "Je deed 10 × 5 in plaats van (10 × 7) : 2."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Driehoek",
        "content": "Oppervlakte driehoek = (basis × hoogte) : 2",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-M7-L203-007",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Reken om: 2,5 m² = ... dm²",
    "options": [
      "250 dm²",
      "25 dm²",
      "2.500 dm²",
      "0,25 dm²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_omrekenen",
    "familyId": "MET-M2-DM2",
    "explanation": "Bij oppervlakte gaat elke stap met ×100. 1 m² = 100 dm². Dus 2,5 × 100 = 250 dm².",
    "distractorExplanations": {
      "1": "Je deed ×10. Bij oppervlakte is het ×100 per stap.",
      "2": "Je deed ×1000. Dat is bij inhoud.",
      "3": "Je deelde in plaats van te vermenigvuldigen."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Oppervlakte omrekenen",
        "content": "Bij oppervlakte: elke stap is ×100 (niet ×10!). Dus m² → dm² is ×100.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-M7-L203-008",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Een tuin is 15 meter lang en 8 meter breed. Hoeveel vierkante meter gras moet je kopen?",
    "options": [
      "120 m²",
      "46 m²",
      "23 m²",
      "240 m²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-TUIN-M7",
    "explanation": "Oppervlakte = lengte × breedte = 15 × 8 = 120 m².",
    "distractorExplanations": {
      "1": "Je berekende de omtrek (2 × 15 + 2 × 8 = 46). Maar we willen hoeveel gras erin past!",
      "2": "Je deed 15 + 8. Maar bij oppervlakte moet je vermenigvuldigen.",
      "3": "Je deed 120 × 2. Eén keer vermenigvuldigen is genoeg."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 15,
        "height": 8,
        "mode": "area",
        "label": "Tuin: 15 × 8 = 120 m²"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-M7-L203-009",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Hoeveel mm² is 3 cm²?",
    "options": [
      "300 mm²",
      "30 mm²",
      "3.000 mm²",
      "0,03 mm²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_omrekenen",
    "familyId": "MET-CM2-MM2",
    "explanation": "Bij oppervlakte gaat elke stap met ×100. 1 cm² = 100 mm². Dus 3 × 100 = 300 mm².",
    "distractorExplanations": {
      "1": "Je deed ×10. Bij oppervlakte is het ×100 per stap.",
      "2": "Je deed ×1000. Dat is bij inhoud.",
      "3": "Je deelde in plaats van te vermenigvuldigen."
    }
  },
  {
    "id": "MET-M7-L203-010",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Een rechthoekig zwembad is 12 meter lang en 6 meter breed. Wat is de omtrek?",
    "options": [
      "36 m",
      "72 m",
      "18 m",
      "48 m"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMT-ZWEMBAD-M7",
    "explanation": "Omtrek = 2 × (lengte + breedte) = 2 × (12 + 6) = 2 × 18 = 36 m.",
    "distractorExplanations": {
      "1": "Je deed 12 × 6. Dat is de oppervlakte, niet de omtrek.",
      "2": "Je telde maar twee kanten op (12 + 6). Een rechthoek heeft vier kanten!",
      "3": "Je deed 12 × 4. Maar de breedte is 6, niet 12."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 12,
        "height": 6,
        "mode": "perimeter",
        "label": "Omtrek: 2 × (12 + 6) = 36 m"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-M7-L203-011",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Een vierkant heeft een oppervlakte van 64 cm². Hoe lang is één zijde?",
    "options": [
      "8 cm",
      "16 cm",
      "32 cm",
      "4 cm"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-VIERKANT-M7",
    "explanation": "Bij een vierkant: zijde × zijde = oppervlakte. 8 × 8 = 64. Dus de zijde is 8 cm.",
    "distractorExplanations": {
      "1": "Je deed 64 : 4. Dat is voor omtrek, niet oppervlakte.",
      "2": "Je deed 64 : 2. Zoek een getal dat × zichzelf = 64.",
      "3": "4 × 4 = 16. Dat is niet 64."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 8,
        "height": 8,
        "mode": "area",
        "label": "Vierkant: 8 × 8 = 64 cm²"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-M7-L203-012",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Reken om: 7.500 m = ... km",
    "options": [
      "7,5 km",
      "75 km",
      "0,75 km",
      "750 km"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte_km_m",
    "familyId": "MET-M-KM-7500",
    "explanation": "Van meter naar kilometer: delen door 1.000. 7.500 : 1.000 = 7,5 km.",
    "distractorExplanations": {
      "1": "Je deelde door 100.",
      "2": "Je deelde door 10.000.",
      "3": "Je deelde door 10."
    }
  },
  {
    "id": "MET-M7-L203-013",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Een rechthoek is 9 cm lang en 5 cm breed. Wat is de oppervlakte?",
    "options": [
      "45 cm²",
      "28 cm²",
      "14 cm²",
      "90 cm²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-RECHTHOEK-M7",
    "explanation": "Oppervlakte = lengte × breedte = 9 × 5 = 45 cm².",
    "distractorExplanations": {
      "1": "Je berekende de omtrek (2 × 9 + 2 × 5 = 28).",
      "2": "Je deed 9 + 5. Bij oppervlakte moet je vermenigvuldigen.",
      "3": "Je deed 45 × 2. Eén keer vermenigvuldigen is genoeg."
    }
  },
  {
    "id": "MET-M7-L203-014",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Een driehoek heeft een basis van 12 cm en een hoogte van 5 cm. Wat is de oppervlakte?",
    "options": [
      "30 cm²",
      "60 cm²",
      "17 cm²",
      "120 cm²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_driehoek",
    "familyId": "MET-OPP-DRIEHOEK-3",
    "explanation": "Oppervlakte driehoek = (basis × hoogte) : 2 = (12 × 5) : 2 = 60 : 2 = 30 cm².",
    "distractorExplanations": {
      "1": "Je bent vergeten te delen door 2.",
      "2": "Je hebt 12 + 5 gedaan.",
      "3": "Je deed 12 × 5 × 2 in plaats van : 2."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Driehoek",
        "content": "Oppervlakte = (basis × hoogte) : 2 = (12 × 5) : 2 = 30 cm²",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-M7-L203-015",
    "module": "Metriek",
    "difficulty": 203,
    "question": "Reken om: 45.000 cm² = ... m²",
    "options": [
      "4,5 m²",
      "45 m²",
      "0,45 m²",
      "450 m²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_omrekenen",
    "familyId": "MET-CM2-M2",
    "explanation": "1 m² = 10.000 cm². Dus 45.000 : 10.000 = 4,5 m².",
    "distractorExplanations": {
      "1": "Je deelde door 1.000.",
      "2": "Je deelde door 100.000.",
      "3": "Je deelde door 100."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "cm² naar m²",
        "content": "1 m² = 10.000 cm². Deel door 10.000 om van cm² naar m² te gaan.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  }
]